import { useState } from "react";
import "./companyDashboardStyles.css";

const navItems = [
  { label: "LMS", anchor: "#lms", url: "https://lms.metbrains.com" },
  { label: "CRM", anchor: "#crm", url: "https://crm.metbrains.com" },
  { label: "HRMS", anchor: "#hrms", url: "https://hrms.metbrains.com" },
  { label: "Job Portal", anchor: "#jobp" },
];

const serviceCards = [
  {
    id: "lms",
    title: "Learning Hub",
    subtitle: "Upskill your teams",
    stat: "12 active cohorts",
    trend: "+3 new launches",
    accent: "📘",
  },
  {
    id: "crm",
    title: "Customer Desk",
    subtitle: "Pipeline & success",
    stat: "48 open deals",
    trend: "23 due this week",
    accent: "📈",
  },
  {
    id: "hrms",
    title: "People Ops",
    subtitle: "Talent & payroll",
    stat: "316 teammates",
    trend: "4 new offers",
    accent: "🧑‍💼",
  },
];

const communityPosts = [
  {
    author: "Apex Labs",
    role: "Talent Operations",
    time: "2h ago",
    body:
      "We just wrapped our AI career accelerator graduation. Sharing highlights and looking for mentors to guide the next cohort.",
    tags: ["Community Update", "AI Talent"],
    engagement: { likes: 92, comments: 18, saves: 8, shares: 4 },
    image:
      "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?auto=format&fit=crop&w=1200&q=80",
    comments: [
      {
        author: "Nora Shin",
        handle: "Chief Learning Officer",
        message: "Congrats team! DMing you to explore a joint mentor pool.",
        time: "30m",
      },
      {
        author: "Devon Patel",
        handle: "People Ops",
        message: "We can host a fireside chat about the accelerator journey.",
        time: "12m",
      },
    ],
  },
  {
    author: "Northwind Digital",
    role: "People Success",
    time: "5h ago",
    body:
      "Launched a cross-company wellness challenge. Drop your best practices for async events that keep globally distributed teams engaged.",
    tags: ["Culture", "Remote Work"],
    engagement: { likes: 61, comments: 23, saves: 11, shares: 6 },
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80",
    comments: [
      {
        author: "Priya Raman",
        handle: "HRBP · QuantumStack",
        message: "Love this! We pair folks randomly for quick walk-and-talk calls.",
        time: "1h",
      },
    ],
  },
];

const insightCards = [
  { value: "94%", label: "Course completion rate" },
  { value: "37", label: "New partner leads" },
  { value: "18", label: "Community mentions" },
];

export const CompanyDashboard = () => {
  const [navLoading, setNavLoading] = useState(false);
  const [navTarget, setNavTarget] = useState("");

  const handleExternalNav = (item) => {
    if (!item.url) {
      return;
    }
    setNavTarget(item.label);
    setNavLoading(true);
    setTimeout(() => {
      window.location.href = item.url;
    }, 900);
  };

  return (
    <div className="cdashf83-shell">
      <header className="cdashf83-header-fixed">
        <div className="cdashf83-header-inner">
          <div className="cdashf83-brand">
            <div className="cdashf83-logo-dot" aria-hidden="true" />
            <div>
              <strong>MetBrains Enterprise</strong>
              <span>Company Portal</span>
            </div>
          </div>

          <nav className="cdashf83-nav">
            {navItems.map((item) =>
              item.url ? (
                <button
                  key={item.label}
                  type="button"
                  className="cdashf83-nav-link as-button"
                  onClick={() => handleExternalNav(item)}
                  disabled={navLoading}
                >
                  {item.label}
                </button>
              ) : (
                <a key={item.label} href={item.anchor} className="cdashf83-nav-link">
                  {item.label}
                </a>
              )
            )}
            <a href="#community" className="cdashf83-nav-link ghost">
              Community
            </a>
          </nav>

          <div className="cdashf83-header-cta">
            <button className="cdashf83-btn ghost">Help</button>
            <button className="cdashf83-btn primary">Share update</button>
          </div>
        </div>
      </header>

      <main className="cdashf83-main">
        <section className="cdashf83-hero">
          <div>
            <p className="cdashf83-eyebrow">Today&apos;s briefing</p>
            <h1>Unified workspace for IT companies</h1>
            <p className="cdashf83-body">
              Keep an eye on learning velocity, customer health, and people operations
              the same way you browse your professional social feeds: clean, focused,
              and actionable.
            </p>
            <div className="cdashf83-hero-actions">
              <button className="cdashf83-btn secondary">Plan rollout</button>
              <button className="cdashf83-btn ghost">View audit log</button>
            </div>
          </div>

          <div className="cdashf83-hero-metrics">
            {insightCards.map((item) => (
              <article key={item.label} className="cdashf83-hero-card">
                <span className="cdashf83-hero-value">{item.value}</span>
                <span className="cdashf83-hero-label">{item.label}</span>
              </article>
            ))}
          </div>
        </section>

        <section className="cdashf83-content">
          <aside className="cdashf83-side">
            <article className="cdashf83-panel">
              <div className="cdashf83-panel-head">
                <div>
                  <p className="cdashf83-eyebrow">Quick access</p>
                  <h3>Priority programs</h3>
                </div>
                <button className="cdashf83-link">View calendar</button>
              </div>
              <ul className="cdashf83-list">
                <li>
                  <strong>Cloud Security Sprint</strong>
                  <span>Kick-off in 02:30 hrs</span>
                </li>
                <li>
                  <strong>Customer migration</strong>
                  <span>7 teams collaborating</span>
                </li>
                <li>
                  <strong>Campus hiring drive</strong>
                  <span>Final interviews next week</span>
                </li>
              </ul>
            </article>

            <section className="cdashf83-service-grid">
              {serviceCards.map((card) => (
                <article key={card.id} id={card.id} className="cdashf83-service-card">
                  <div className="cdashf83-service-accent" aria-hidden="true">
                    {card.accent}
                  </div>
                  <div>
                    <h4>{card.title}</h4>
                    <p>{card.subtitle}</p>
                  </div>
                  <div className="cdashf83-service-stat">
                    <span>{card.stat}</span>
                    <small>{card.trend}</small>
                  </div>
                  <button className="cdashf83-link">Launch {card.title}</button>
                </article>
              ))}
            </section>
          </aside>

          <section className="cdashf83-feed-panel" id="community">
            <div className="cdashf83-panel-head feed-head">
              <div>
                <p className="cdashf83-eyebrow">Community pulse</p>
                <h3>Live conversations</h3>
              </div>
              <button className="cdashf83-btn primary">Start a post</button>
            </div>

            <div className="cdashf83-feed">
              {communityPosts.map((post, index) => (
                <article key={post.author + index} className="cdashf83-post">
                  <header>
                    <div>
                      <strong>{post.author}</strong>
                      <span>{post.role}</span>
                    </div>
                    <time>{post.time}</time>
                  </header>

                  <p>{post.body}</p>

                  {post.image && (
                    <div className="cdashf83-post-media">
                      <img src={post.image} alt={`${post.author} update`} loading="lazy" />
                    </div>
                  )}

                  <div className="cdashf83-tags">
                    {post.tags.map((tag) => (
                      <span key={tag}>{tag}</span>
                    ))}
                  </div>

                  <footer className="cdashf83-engagement">
                    <span>👍 {post.engagement.likes}</span>
                    <span>💬 {post.engagement.comments}</span>
                    <span>🔖 {post.engagement.saves}</span>
                    <span>↗ {post.engagement.shares}</span>
                  </footer>

                  <div className="cdashf83-post-actions">
                    <button type="button">Like</button>
                    <button type="button">Comment</button>
                    <button type="button">Share</button>
                    <button type="button">Save</button>
                  </div>

                  <div className="cdashf83-comment-list">
                    {post.comments.map((comment, commentIndex) => (
                      <div key={comment.author + commentIndex} className="cdashf83-comment">
                        <div className="cdashf83-comment-avatar">
                          {comment.author
                            .split(" ")
                            .map((p) => p[0])
                            .join("")
                            .slice(0, 2)}
                        </div>
                        <div className="cdashf83-comment-body">
                          <div className="cdashf83-comment-head">
                            <strong>{comment.author}</strong>
                            <span>{comment.handle}</span>
                            <time>{comment.time}</time>
                          </div>
                          <p>{comment.message}</p>
                        </div>
                      </div>
                    ))}

                    <div className="cdashf83-comment-input">
                      <div className="cdashf83-comment-avatar">You</div>
                      <input
                        type="text"
                        placeholder="Add a comment..."
                        aria-label="Add a comment"
                      />
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <aside className="cdashf83-side right">
            <article className="cdashf83-panel">
              <div className="cdashf83-panel-head">
                <div>
                  <p className="cdashf83-eyebrow">Engagement</p>
                  <h3>Team health</h3>
                </div>
                <button className="cdashf83-link">View report</button>
              </div>
              <ul className="cdashf83-list compact">
                <li>
                  <strong>Pulse score</strong>
                  <span>8.9 / 10</span>
                </li>
                <li>
                  <strong>Attrition risk</strong>
                  <span>Low · 1.4%</span>
                </li>
                <li>
                  <strong>Internal mobility</strong>
                  <span>22 moves this quarter</span>
                </li>
              </ul>
            </article>

            <article className="cdashf83-panel promo">
              <p className="cdashf83-eyebrow">Community beta</p>
              <h3>Publish public stories</h3>
              <p className="cdashf83-body">
                Showcase milestones, spotlight leaders, and attract future partners with
                multimedia posts.
              </p>
              <button className="cdashf83-btn secondary">Preview community</button>
            </article>
          </aside>
        </section>
      </main>
      {navLoading && (
        <div className="cdashf83-full-loader">
          <div className="cdashf83-loader-spinner" />
          <p>Opening {navTarget} workspace...</p>
        </div>
      )}
    </div>
  );
};